module.exports = __webpack_public_path__ + "images/icons/icon-shop-b949b147.svg";